import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-recording-dialog',
  templateUrl: './recording-dialog.component.html',
  styleUrls: ['./recording-dialog.component.scss']
})

export class RecordingDialogComponent implements OnInit {
  @Input() audioSource: string;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @ViewChild('audioOption', { static: true }) audioPlayerRef: ElementRef;

  constructor() {
  }

  ngOnInit() { }

  /**
 * Name: closeDailog
 * purpose: To close Dailog
 */
  closeDailog(): void {
    this.audioPlayerRef.nativeElement.pause();
    this.audioPlayerRef.nativeElement.currentTime = 0;
    this.close.emit(null);
  }
}
